// this was used when developing the WYSIWYG implementation. I thought it was useful enough to leave in but took out all the production data I was using.
export const TESTING_USE_CASES = [
    `<a href="https://www.google.com">test</a>`,
    `this is a <a href="https://www.google.com">test</a>. An there should be a link in the middle`
];
